<template lang="pug">
v-container.px-8.pb-8(style="max-width: 1600px")
  v-row.mb-2(no-gutters align="center")
    v-col.shrink
      v-btn.ml-n3(text icon @click="$router.push('/admin/clinic/settings')" height)
        v-icon(color="neutral700" :size="24") mdi-arrow-left
    v-col.ml-3
      .text-2xl.font-semibold.neutral700--text User Logs
  user-log
</template>

<script>
import UserLog from '@/components/clinic/usersettings/UserLog.vue'

export default {
  components: {
    UserLog,
  }
}
</script>

<style scoped>
</style>